import React from 'react'
import GroupSelect from 'admin/components/shared/GroupSelect'
import InputField from 'admin/components/shared/InputField'

export default ({q, includeGroupIds = [], excludeGroupIds = [], dashboard, onSubmit}) => {
  const handleSearch = changes => onSubmit({...changes, page: 1})
  const handleIncludeGroupSelect = group => onSubmit({includeGroupIds: includeGroupIds.concat([group.id]), page: 1})
  const handleExcludeGroupSelect = group => onSubmit({excludeGroupIds: excludeGroupIds.concat([group.id]), page: 1})

  const handleIncludeGroupUnselect = group =>
    onSubmit({includeGroupIds: includeGroupIds.filter(id => String(id) !== String(group.id)), page: 1})

  const handleExcludeGroupUnselect = group =>
    onSubmit({excludeGroupIds: excludeGroupIds.filter(id => String(id) !== String(group.id)), page: 1})

  return (
    <form className='box is-radiusless is-shadowless has-background-filters'>
      <div className='field is-grouped'>
        <div className='control is-expanded'>
          <InputField
            type='search'
            name='q'
            label='Search'
            autoComplete='off'
            value={q}
            debounce={true}
            onChange={handleSearch}
          />
        </div>
      </div>

      {dashboard ? (
        <div className='field'>
          <div className='control'>
            <div className='tags has-addons'>
              <span className='tag is-dark'>
                <b>Dashboard</b>: {dashboard}
              </span>
              <a
                className='tag is-delete has-background-dark has-text-white'
                onClick={() => onSubmit({dashboard: null})}></a>
            </div>
          </div>
        </div>
      ) : null}

      <div className='field'>
        <div className='control'>
          <GroupSelect
            selectedIds={includeGroupIds}
            onUnselect={handleIncludeGroupUnselect}
            onSelect={handleIncludeGroupSelect}
            buttonPosition='top'
            buttonText={
              <span>
                <b>Include</b> groups
              </span>
            }
          />
        </div>
      </div>
      <div className='field'>
        <div className='control'>
          <GroupSelect
            selectedIds={excludeGroupIds}
            onUnselect={handleExcludeGroupUnselect}
            onSelect={handleExcludeGroupSelect}
            tagPrefix='NOT'
            buttonPosition='top'
            buttonText={
              <span>
                <b>Exclude</b> groups
              </span>
            }
          />
        </div>
      </div>
    </form>
  )
}
